import { render, staticRenderFns } from "./AreceivableTable.vue?vue&type=template&id=566c07bc&scoped=true"
import script from "./AreceivableTable.vue?vue&type=script&lang=js"
export * from "./AreceivableTable.vue?vue&type=script&lang=js"
import style0 from "./AreceivableTable.vue?vue&type=style&index=0&id=566c07bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566c07bc",
  null
  
)

export default component.exports